import React from 'react';
import CommonBanner from "../component/Common/CommonBanner";
import { ImageConstants } from "../assets/img/ImageConstants";
import StaticSEOTags from '../component/DynamicSEO/StaticSEOTags';
import Img from "../assets/img/imagination/tourall.jpg";

const AdventureLeisureTours = () => {
  return (
    <>
      <StaticSEOTags
        fallbackTitle="Adventure & Leisure Tours - Polani Travels"
        fallbackDescription="Experience the world beyond the ordinary with Polani Travels' adventure and leisure tours. Tailored travel experiences for thrill-seekers and relaxation seekers."
        fallbackKeywords="adventure tours, leisure tours, adventure travel, leisure travel, hiking, desert safari, ziplining, paragliding, skiing, scuba diving, Polani Travels"
        fallbackOgTitle="Adventure & Leisure Tours - Polani Travels"
        fallbackOgDescription="Craft unforgettable memories with our adventure and leisure tours. From thrilling activities to peaceful retreats."
        fallbackCanonicalUrl="https://poliflytravels.com/domestic-international-stays/"
      />

      <CommonBanner
        heading="Adventure & Leisure Tours"
        img={ImageConstants.visabanner}
        pagination="Adventure & Leisure Tours"
      />

      <section className="adventure-leisure-tours-area pt-5 pb-5 mt-5 mb-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <div className="content-wrapper visa-content">
                <h2 className="mb-4">Polani Travels – Your Travel Partner for Every Adventure & Leisure Journey</h2>
                <h4 className="mb-3">Experience the World Beyond the Ordinary</h4>
                <p className="mb-5">
                  At Polani Travels, we believe that travel isn't just about visiting new places — it's about creating unforgettable memories, pushing your boundaries, and taking a break from the ordinary. Our Adventure and Leisure Tours are crafted for those who seek thrill, relaxation, or the perfect mix of both.
                </p>
                <p className="mb-5">
                  Whether you're a solo adventurer, a couple on a romantic escape, or a family looking for fun-filled moments, we offer tailored travel experiences that match your preferences, comfort, and budget.
                </p>
              </div>
            </div>

            <div className="col-lg-6">
            <img src={Img} alt="img" />
            </div>

          </div>
          <div className='row mt-5 pb-5'>
            <div className='col-lg-6'>
            <div className="mb-5">
                  <h3 className="mb-3">Discover a World of Possibilities</h3>
                  <p>
                    With Polani Travels, your dream destination is just a plan away. From breathtaking mountains to exotic beaches, city lights to tranquil hideaways, our tours cover it all. Want to skydive in Dubai, hike in Hunza, ride a hot air balloon in Cappadocia, or relax in the Maldives? We've got you covered — locally and globally.
                  </p>
                </div> 
                </div>
            <div className='col-lg-6'>  
            <div className="mb-5">
                  <h3 className="mb-3">What's Included in Our Adventure & Leisure Tours?</h3>
                  <p>Each package is designed to give you a seamless, safe, and exciting experience. Here's what to expect:</p>
                  <ul className="benefits-list">
                    <li><strong>All-Inclusive Travel Planning:</strong> We handle everything from A to Z — flights, hotels, transport, guided tours, and excursions. You just show up and enjoy the experience.</li>
                    <li><strong>Flexible and Personalized Options:</strong> Choose your destination, duration, travel style, and pace. Whether it's a weekend escape or a two-week journey, we customize every tour to your needs.</li>
                    <li><strong>Expert Local Guides:</strong> We work with knowledgeable, vetted local guides who add depth to your journey, ensure safety, and help you truly connect with each destination.</li>
                    <li><strong>Safe & Comfortable Accommodations:</strong> We select reliable, quality hotels and resorts, from cozy budget stays to premium luxury — all chosen for comfort, location, and service.</li>
                  </ul>
                </div>
              
            </div>
          </div>

          <div className='row'>
            <div className='col-lg-6'>
        
                <div className="mb-5">
                  <h3 className="mb-3">Exciting Activities for All Interests</h3>
                  <p>Choose from a wide variety of adventures and leisure activities:</p>
                  <ul className="benefits-list">
                    <li><strong>Adventure:</strong> Hiking, desert safari, ziplining, paragliding, skiing, scuba diving, and more</li>
                    <li><strong>Leisure:</strong> Spa treatments, cultural tours, shopping, sightseeing, and food experiences</li>
                    <li><strong>Family-Friendly:</strong> Balanced itineraries with safe, engaging activities for all age groups</li>
                  </ul>
                </div> </div>
            <div className='col-lg-6'>  
          
                <div className="mb-5">
                  <h3 className="mb-3">Top Adventure & Leisure Destinations</h3>
                  <p>Our most popular tour packages include:</p>
                  <ul className="benefits-list">
                    <li><strong>Northern Pakistan:</strong> Hunza, Skardu, Swat, Fairy Meadows</li>
                    <li><strong>Turkey:</strong> Istanbul, Cappadocia, Antalya</li>
                    <li><strong>UAE:</strong> Dubai Skydiving, Desert Safaris, Luxury Stays</li>
                    <li><strong>Thailand:</strong> Beaches, Nightlife, Island Hopping</li>
                    <li><strong>Malaysia & Indonesia:</strong> Nature, Culture, Beach Resorts</li>
                    <li><strong>Maldives & Sri Lanka:</strong> Honeymoon escapes, Water sports, Relaxation</li>
                    <li><strong>Europe:</strong> France, Switzerland, Italy – perfect for scenic leisure tours</li>
                  </ul>
                </div>
            </div>
          </div>

          <div className='row'>
            <div className='col-lg-6'>
        
                <div className="mb-5">
                  <h3 className="mb-3">Fully Customizable for Any Occasion</h3>
                  <p>
                    Every traveler is different — and we embrace that. Whether it's a honeymoon, birthday, anniversary surprise, solo retreat, friends' getaway, or corporate team retreat, we design trips around your exact goals. We also arrange school trips, group tours, and institutional retreats with complete safety and planning.
                  </p>
                </div> </div>
            <div className='col-lg-6'>  
          
                <div className="get-in-touch mb-5">
                  <h3 className="mb-3">Travel Smart with Polani Travels</h3>
                  <p>
                    At Polani Travels, we bring years of experience, passion, and personalized care to every journey. From visa support and travel insurance to airport pickups and return flights, we manage it all — so you can focus on what matters most: living the adventure.
                  </p>
                  <h3 className="mb-3 mt-4">Book Your Next Adventure Today!</h3>
                  <p>
                    Ready to escape, explore, or unwind? Get in touch with Polani Travels and let's craft a travel experience that's just right for you.
                  </p>
                  <p className="mt-3 mb-5"><strong>📞 Call now or visit our office to begin your next great journey.</strong></p>
                  <p className="mt-3"><strong>Polani Travels – Adventure, Leisure & Everything in Between.</strong></p>
               
                </div>
            </div>
          </div>
         
        </div>
      </section>
    </>
  );
};

export default AdventureLeisureTours; 